(function () {
	// Function to get all the next siblings of an element
	const nextSiblings = (currentElement) => {
		let next_siblings = [];
		let sibling = currentElement.nextElementSibling;

		while (sibling) {
			next_siblings.push(sibling);
			sibling = sibling.nextElementSibling;
		}

		return next_siblings;
	}

	const footer = () => {
		 const caculateNewsletterMargin = () => {
			//debugger;
			const footerNewsletter = document.querySelector(".footer--newsletter__form--center");

		// Only proceed if the newsletter form exists
		if (footerNewsletter) {
			let footerParent = footerNewsletter.parentNode;
			let footerStyles = window.getComputedStyle(footerParent);

			// Calculate the total height of next siblings
			let marginTop = nextSiblings(footerNewsletter).reduce((totalHeight, sibling) => {
				const siblingHeight = sibling.offsetHeight || 0; // Handle hidden elements
				return totalHeight + siblingHeight;
			}, 0) - parseInt(footerStyles.getPropertyValue('padding-top'), 10);
			
			let enoughSpace = (window.outerHeight - marginTop * 2 - footerNewsletter.offsetHeight) > 0;

			marginTop = marginTop > 0 && enoughSpace ? marginTop : 0;

			// Apply the calculated margin to the newsletter
			footerNewsletter.style.marginTop = `${marginTop}px`;
		 }
		}

		caculateNewsletterMargin();
		window.addEventListener("resize", () => setTimeout(() =>caculateNewsletterMargin(), 500));
	}

	// Reapply the footer logic when the section is reloaded
	document.addEventListener('shopify:section:load', footer);
	footer();
})();

(function () {
	var FORM_SELECTOR = '.footer form.newsletter-form';
	var FAIL_MS = 15000;
	var SUCCESS_FALLBACK_MS = 1200;
	var MIN_LOADING_MS = 2200;

	var bindFooterNewsletterForms = function () {
		document.querySelectorAll(FORM_SELECTOR).forEach(bindFooterNewsletterForm);
	};

	var bindFooterNewsletterForm = function (formEl) {
		if (formEl.dataset.footerNewsletterBound === 'true') {
			return;
		}

		formEl.dataset.footerNewsletterBound = 'true';
		formEl.setAttribute('data-shopify-captcha', 'true');
		attachNewsletterIframe(formEl);

		// Shopify captcha replaces form.submit after wiring. Assign a native
		// iframe submit first so captcha captures it and calls it with a token.
		try {
			formEl.submit = function () {
				postNewsletterFormNative(formEl);
			};
		} catch (err) {}

		protectNewsletterForm(formEl);

		formEl.addEventListener(
			'submit',
			function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();

				if (formEl.dataset.footerNewsletterLoading === 'true') {
					return;
				}

				if (formEl.dataset.footerNewsletterSuccess === 'true') {
					return;
				}

				if (typeof formEl.reportValidity === 'function' && !formEl.reportValidity()) {
					return;
				}

				markNewsletterSubmitting(formEl);
				runNewsletterCaptchaSubmit(formEl);
			},
			true
		);
	};

	var attachNewsletterIframe = function (formEl) {
		var name = (formEl.id || 'FooterNewsletterForm') + '-frame';
		var iframe = document.getElementById(name);

		if (!iframe) {
			iframe = document.createElement('iframe');
			iframe.name = name;
			iframe.id = name;
			iframe.title = 'Newsletter';
			iframe.setAttribute('aria-hidden', 'true');
			iframe.tabIndex = -1;
			iframe.style.cssText =
				'position:absolute;width:0;height:0;border:0;overflow:hidden;visibility:hidden';
			formEl.parentNode.insertBefore(iframe, formEl.nextSibling);

			iframe.addEventListener('load', function () {
				if (formEl.dataset.footerNewsletterExpecting !== 'true') {
					return;
				}

				formEl.dataset.footerNewsletterExpecting = '';

				try {
					var href = iframe.contentWindow.location.href || '';
					if (href.indexOf('/challenge') !== -1) {
						failNewsletterForm(formEl);
						return;
					}
				} catch (err) {
					// X-Frame-Options may block reading the response; the POST still ran.
				}

				showNewsletterSuccess(formEl);
			});
		}

		formEl.setAttribute('target', name);
	};

	var protectNewsletterForm = function (formEl, callback) {
		if (formEl.getAttribute('data-hcaptcha-bound') === 'true') {
			if (typeof callback === 'function') {
				callback();
			}
			return;
		}

		if (formEl.dataset.cptcha === 'true' && typeof callback === 'function') {
			var started = Date.now();
			var wait = function () {
				if (formEl.getAttribute('data-hcaptcha-bound') === 'true') {
					callback();
					return;
				}

				if (Date.now() - started > 8000) {
					failNewsletterForm(formEl);
					return;
				}

				setTimeout(wait, 50);
			};
			wait();
			return;
		}

		var captcha = window.Shopify && window.Shopify.captcha;
		if (captcha && typeof captcha.protect === 'function') {
			try {
				captcha.protect(formEl, callback);
				return;
			} catch (err) {}
		}

		if (typeof callback === 'function') {
			callback();
		}
	};

	var runNewsletterCaptchaSubmit = function (formEl) {
		var submitWithCaptcha = function () {
			try {
				formEl.submit();
			} catch (err) {
				failNewsletterForm(formEl);
				return;
			}

			if (formEl.dataset.footerNewsletterExpecting !== 'true') {
				return;
			}

			// X-Frame-Options can block the iframe response/load event. If the POST
			// already went out, show success shortly after without moving the page.
			if (formEl._footerNewsletterSuccessTimer) {
				clearTimeout(formEl._footerNewsletterSuccessTimer);
			}
			formEl._footerNewsletterSuccessTimer = setTimeout(function () {
				if (formEl.dataset.footerNewsletterExpecting === 'true') {
					formEl.dataset.footerNewsletterExpecting = '';
					showNewsletterSuccess(formEl);
				}
			}, SUCCESS_FALLBACK_MS);
		};

		protectNewsletterForm(formEl, submitWithCaptcha);
	};

	var getNewsletterErrorMessage = function (formEl) {
		var errorEl = formEl.querySelector('[data-footer-newsletter-error]');
		return (
			formEl.getAttribute('data-newsletter-error') ||
			(errorEl && errorEl.getAttribute('data-error-message')) ||
			'No pudimos completar tu suscripción. Inténtalo de nuevo.'
		);
	};

	var markNewsletterSubmitting = function (formEl) {
		var errorEl = formEl.querySelector('[data-footer-newsletter-error]');
		var submitEl = formEl.querySelector('[data-footer-newsletter-submit]');

		formEl.dataset.footerNewsletterExpecting = 'true';
		formEl.dataset.footerNewsletterLoading = 'true';
		formEl._footerNewsletterStartedAt = Date.now();

		if (errorEl) {
			errorEl.setAttribute('hidden', '');
			errorEl.textContent = '';
		}

		if (submitEl) {
			submitEl.classList.add('loading');
			submitEl.setAttribute('aria-busy', 'true');
			setTimeout(function () {
				submitEl.disabled = true;
			}, 0);
		}

		if (formEl._footerNewsletterFailTimer) {
			clearTimeout(formEl._footerNewsletterFailTimer);
		}

		formEl._footerNewsletterFailTimer = setTimeout(function () {
			if (formEl.dataset.footerNewsletterLoading === 'true') {
				failNewsletterForm(formEl);
			}
		}, FAIL_MS);
	};

	var clearNewsletterTimers = function (formEl) {
		if (formEl._footerNewsletterFailTimer) {
			clearTimeout(formEl._footerNewsletterFailTimer);
			formEl._footerNewsletterFailTimer = null;
		}
		if (formEl._footerNewsletterSuccessTimer) {
			clearTimeout(formEl._footerNewsletterSuccessTimer);
			formEl._footerNewsletterSuccessTimer = null;
		}
		if (formEl._footerNewsletterRevealTimer) {
			clearTimeout(formEl._footerNewsletterRevealTimer);
			formEl._footerNewsletterRevealTimer = null;
		}
	};

	var failNewsletterForm = function (formEl) {
		var errorEl = formEl.querySelector('[data-footer-newsletter-error]');
		var submitEl = formEl.querySelector('[data-footer-newsletter-submit]');

		formEl.dataset.footerNewsletterExpecting = '';
		formEl.dataset.footerNewsletterLoading = 'false';
		clearNewsletterTimers(formEl);

		if (submitEl) {
			submitEl.classList.remove('loading');
			submitEl.disabled = false;
			submitEl.removeAttribute('aria-busy');
		}

		if (errorEl) {
			errorEl.removeAttribute('hidden');
			errorEl.textContent = getNewsletterErrorMessage(formEl);
		}
	};

	var showNewsletterSuccess = function (formEl) {
		if (formEl.dataset.footerNewsletterSuccess === 'true') {
			return;
		}

		var started = formEl._footerNewsletterStartedAt || Date.now();
		var remaining = MIN_LOADING_MS - (Date.now() - started);

		if (remaining > 50) {
			if (formEl._footerNewsletterRevealTimer) {
				clearTimeout(formEl._footerNewsletterRevealTimer);
			}
			formEl._footerNewsletterRevealTimer = setTimeout(function () {
				revealNewsletterSuccess(formEl);
			}, remaining);
			return;
		}

		revealNewsletterSuccess(formEl);
	};

	var revealNewsletterSuccess = function (formEl) {
		if (formEl.dataset.footerNewsletterSuccess === 'true') {
			return;
		}

		formEl.dataset.footerNewsletterSuccess = 'true';
		formEl.dataset.footerNewsletterExpecting = '';
		formEl.dataset.footerNewsletterLoading = 'false';
		clearNewsletterTimers(formEl);

		var fieldsEl = formEl.querySelector('[data-footer-newsletter-fields]');
		var successEl = formEl.querySelector('[data-footer-newsletter-success]');
		var errorEl = formEl.querySelector('[data-footer-newsletter-error]');
		var submitEl = formEl.querySelector('[data-footer-newsletter-submit]');

		if (errorEl) {
			errorEl.setAttribute('hidden', '');
			errorEl.textContent = '';
		}

		if (submitEl) {
			submitEl.classList.remove('loading');
			submitEl.disabled = true;
			submitEl.removeAttribute('aria-busy');
		}

		formEl.classList.add('is-newsletter-success');

		if (fieldsEl) {
			fieldsEl.hidden = true;
			fieldsEl.setAttribute('hidden', '');
		}

		if (successEl) {
			successEl.hidden = false;
			successEl.removeAttribute('hidden');
		}
	};

	var postNewsletterFormNative = function (formEl) {
		var tokenField = formEl.querySelector('[name="h-captcha-response"]');
		if (!tokenField || !tokenField.value) {
			failNewsletterForm(formEl);
			return;
		}

		attachNewsletterIframe(formEl);
		formEl.dataset.footerNewsletterExpecting = 'true';
		HTMLFormElement.prototype.submit.call(formEl);
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bindFooterNewsletterForms);
	} else {
		bindFooterNewsletterForms();
	}

	document.addEventListener('shopify:section:load', bindFooterNewsletterForms);
})();


//(function () {
//	const nextSiblings = (currentElement) => {
//		let next_siblings = [];
//		let sibling = currentElement.nextElementSibling;

//		while (sibling) {
//			next_siblings.push(sibling);
//			sibling = sibling.nextElementSibling;
//		}

//		return next_siblings;
//	}

//	const footer = () => {
//		const caculateNewsletterMargin = () => {
//			const footerNewsletter = document.querySelector(".footer--newsletter__form--center");

//			if (footerNewsletter) {
//				let footerParent = footerNewsletter.parentNode;
//				let footerStyles = window.getComputedStyle(footerParent);

//				// Calculate total height of next siblings only if needed
//				let marginTop = nextSiblings(footerNewsletter).reduce((totalHeight, sibling) => {
//					const siblingHeight = sibling.offsetHeight || 0;
//					return totalHeight + siblingHeight;
//				}, 0) - parseInt(footerStyles.getPropertyValue('padding-top'), 10);

//				let enoughSpace = (window.innerHeight - marginTop * 2 - footerNewsletter.offsetHeight) > 0;

//				// Apply margin only if necessary
//				footerNewsletter.style.marginTop = enoughSpace && marginTop > 0 ? `${marginTop}px` : '0';
//			}
//		}

//		// Re-run calculations on window resize or Swiper updates
//		caculateNewsletterMargin();
//		window.addEventListener("resize", () => setTimeout(caculateNewsletterMargin, 500));

//		document.addEventListener('swiper-init', () => setTimeout(caculateNewsletterMargin, 500));
//	}

//	document.addEventListener('shopify:section:load', footer);
//	footer();

//	// Trigger calculation after Swiper init
//	if (typeof Swiper !== 'undefined') {
//		const swiperInstance = new Swiper('.swiper-container', {
//			on: {
//				init: function() {
//					const event = new Event('swiper-init');
//					document.dispatchEvent(event);
//				},
//				resize: function() {
//					const event = new Event('swiper-init');
//					document.dispatchEvent(event);
//				}
//			}
//		});
//	}
//})();